import { render, staticRenderFns } from "./KinvaTemplatePage.vue?vue&type=template&id=2e37ec70&scoped=true"
import script from "./KinvaTemplatePage.vue?vue&type=script&lang=js"
export * from "./KinvaTemplatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e37ec70",
  null
  
)

export default component.exports